import React from 'react'
import PropTypes from 'prop-types'
import Icon from './Icon'
import HeaderButton from './HeaderButton'

const StoresBrowser = ({ MorrisonsDaily, altHeaderColour }) => {
  let dataLayer
  console.log('MorrisonsDaily', MorrisonsDaily)
  if (typeof window !== `undefined`) {
    dataLayer = window.dataLayer
  }

  function clickStoresByName() {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'viewStoresByName',
      })
    }
  }

  function clickStoresByRegion() {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'viewStoresByRegion',
      })
    }
  }

  function clickStoresByMorrisonsDaily() {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'viewMorrisonsDailyStores',
      })
    }
  }

  return (
    <section className="w-full lg:w-2/3">
      <div className="mb-4">
        <h2
          className={`text-xl font-semibold  md:text-2xl ${
            altHeaderColour ? '' : 'text-white'
          }`}
        >
          Looking for a specific store?
        </h2>
      </div>
      <div className="flex -mx-2 md:mx-0">
        <div className="flex flex-wrap -mx-2 -mb-2">
          <div
            className={`mx-1 mb-2 ${MorrisonsDaily ? 'order-2' : 'order-1'}`}
          >
            <HeaderButton
              rounded
              opaque
              href={`/list`}
              onClick={clickStoresByName}
            >
              <div className={`flex `}>
                <span className="block font-semibold whitespace-no-wrap">
                  Morrisons Stores by name
                </span>
                <Icon
                  icon="forwardArrow"
                  className="inline-block w-3 h-3 my-auto ml-3 fill-current"
                />
              </div>
            </HeaderButton>
          </div>

          <div
            className={`mx-1 mb-2 ${MorrisonsDaily ? 'order-3' : 'order-2'}`}
          >
            <HeaderButton
              rounded
              opaque
              href={`/region`}
              onClick={clickStoresByRegion}
            >
              <div className={`flex `}>
                <span className="block font-semibold whitespace-no-wrap">
                  Morrisons Stores by region
                </span>
                <Icon
                  icon="forwardArrow"
                  className="inline-block w-3 h-3 my-auto ml-3 fill-current "
                />
              </div>
            </HeaderButton>
          </div>
          <div
            className={`mx-1 mb-2 ${MorrisonsDaily ? 'order-1' : 'order-3'}`}
          >
            <HeaderButton
              rounded
              opaque
              href={`/morrisons-daily-stores`}
              onClick={clickStoresByMorrisonsDaily}
            >
              <div className={`flex `}>
                <span className="block font-semibold whitespace-no-wrap">
                  Morrisons Daily Stores
                </span>
                <Icon
                  icon="forwardArrow"
                  className="inline-block w-3 h-3 my-auto ml-3 fill-current "
                />
              </div>
            </HeaderButton>
          </div>
        </div>
      </div>
    </section>
  )
}
StoresBrowser.propTypes = {
  MorrisonsDaily: PropTypes.bool,
}
export default StoresBrowser
